module.exports = __webpack_public_path__ + "img/image-4.91e1005f.jpg";